<template>
    <div>
        <Head title="Редагувати правило бонусу"/>
        <h1 class="mb-8 text-3xl font-bold">
            <Link class="text-indigo-400 hover:text-indigo-600" :href="$route('bonus-rules.index')">
                Правила бонусу
            </Link>
            <span class="text-indigo-400 font-medium"> /</span> Редагування
        </h1>
        <div class="max-w-lg bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="update">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <text-input v-model="form.name" :error="form.errors.name"
                                class="pb-8 pr-6 w-full" label="Назва"/>
                    <text-input v-model="form.min_amount" :error="form.errors.min_amount"
                                class="pb-8 pr-6 w-full lg:w-1/2" label="Мінімальна загальна сума замовлень (грн)"
                                type="number" min="0" step="0.01"/>
                    <text-input v-model="form.bonus_percent" :error="form.errors.bonus_percent"
                                class="pb-8 pr-6 w-full lg:w-1/2" label="Бонус (%)"
                                type="number" min="0" max="100" step="0.01"/>
                    <checkbox v-model="form.is_active" :error="form.errors.is_active"
                              class="pb-8 pr-6 w-full" label="Активне"/>
                </div>
                <div class="flex items-center justify-between px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <button type="button" class="text-red-600 hover:underline text-sm" @click="destroy">
                        Видалити
                    </button>
                    <loading-button :loading="form.processing" class="btn-indigo" type="submit">
                        Зберегти
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import Checkbox from '@/Shared/Checkbox'

export default {
    components: { Head, Link, LoadingButton, TextInput, Checkbox },
    layout: Layout,
    props: {
        rule: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                name:          this.rule.name,
                min_amount:    this.rule.min_amount,
                bonus_percent: this.rule.bonus_percent,
                is_active:     this.rule.is_active,
            }),
        }
    },
    methods: {
        update() {
            this.form.put(this.$route('bonus-rules.update', this.rule.id))
        },
        destroy() {
            if (confirm('Видалити це правило?')) {
                this.$inertia.delete(this.$route('bonus-rules.destroy', this.rule.id))
            }
        },
    },
}
</script>
